import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils/shadcn";
import { Center } from "@/shared/ui/Blocks";

const badgeVariants = cva("rounded-lg aspect-square", {
  variants: {
    bg: {
      white: "bg-white",
      purple: "bg-purple-500",
      "purple-light": "bg-purple-500/10",
      primary: "bg-primary text-white",
      "primary-light": "bg-primary/10",
      grey: "bg-gray-500",
      "grey-light": "bg-gray-500/10",
      black: "bg-black",
      "black-light": "bg-black/10",
      blue: "bg-blue-500 text-white",
      "blue-light": "bg-blue-500/10",
      lightBlue: "bg-blue-100 text-primary",
      green: "bg-green-500",
      "green-light": "bg-green-500/10",
      red: "bg-red-500",
      "red-light": "bg-red-500/10",
      orange: "bg-orange-500",
      "orange-light": "bg-orange-500/10",
    },
    size: {
      xs: "w-7 h-7",
      sm: "w-9 h-9",
      md: "w-10 h-10",
      lg: "w-14 h-14",
      xl: "w-16 h-16",
    },
  },
  defaultVariants: {
    bg: "blue",
    size: "sm",
  },
});

export interface BadgeProps extends VariantProps<typeof badgeVariants> {
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  className,
  bg,
  size = "sm",
  children,
}) => (
  <Center className={cn(badgeVariants({ bg, size, className }))}>
    {children}
  </Center>
);

export { Badge };
